import { render, unmount } from 'rc-util/lib/React/render';
import React, { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { registerStyleSheet } from '@/utils/common-kit';
import { ITableLayer } from '@/version-types';
import { InnerTableLayer } from '../view/table-layer';

type PromiseFn<T extends (...args: any) => any> = (...args: Parameters<T>) => Promise<ReturnType<T>>;

const renderPromise: PromiseFn<typeof render> = (node, container) =>
    new Promise<void>((resolve) => {
        const Root: React.FC<{
            onMount: () => void;
            children: React.ReactNode;
        }> = ({ onMount, children }) => {
            useEffect(() => {
                onMount();
            }, []);
            return <>{children}</>;
        };
        render(<Root onMount={resolve}>{node}</Root>, container);
    });

type TaskFn = (containerEl: HTMLDivElement, containerElId: string) => Promise<void> | void;

const renderTempTableLayer = async ({
    stageScale,
    layer,
    task,
}: {
    stageScale: number;
    layer: ITableLayer | ITableLayer<true>;
    task: TaskFn;
}) => {
    const containerElId = `css-${uuidv4()}`;
    const containerEl = document.createElement('div');
    containerEl.id = containerElId;
    const removeStyleSheet = registerStyleSheet(`
        #${containerElId} {
            user-select: none;
            pointer-events: none;

            position: fixed;
            top: -100vh;
            left: -100vw;
            z-index: -1;
        }
    `);
    document.body.appendChild(containerEl);
    await renderPromise(
        <div style={{ transform: `scale(${stageScale})`, transformOrigin: 'top left' }}>
            <InnerTableLayer layer={layer as ITableLayer} isNavigator={false} />
        </div>,
        containerEl,
    );

    await task(containerEl, containerElId);

    unmount(containerEl);
    document.body.removeChild(containerEl);
    removeStyleSheet();
};

export default renderTempTableLayer;
